import {Divider} from '@mui/material'
import {motion} from 'framer-motion'
import moment from 'moment'

import './listHistory.scss'

const ListHistory = ({history, onClick}) => {
    return <motion.div
        initial={{x: 400}}
        animate={{x: 0}}
        transition={{duration: 0.3}}>
        <div className={'list-history'}>
            {history.map((item, index) => <div key={index} className={'div-history'} onClick={() => onClick(item)}>
                <label className={'title'}>
                    {`${item.itens[0].quantidade}x ${item.itens[0].titulo}`}
                </label>
                <div className={'items'}>
                    <label className={'label'}>
                        N°
                    </label>
                    <label className={'label'}>
                        {`#${item.id_pedido.slice(-4)}`}
                    </label>
                </div>
                <div className={'items'}>
                    <label className={'label'}>
                        Data
                    </label>
                    <label className={'label'}>
                        {`${moment(item.dataHora, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD/MM/YY')}`}
                    </label>
                </div>
                <div className={'items'}>
                    <label className={'label'}>
                        Status
                    </label>
                    <label className={'label'}>
                        {item.retorno.status}
                    </label>
                </div>
                {(!!item?.versao) && <>
                    <div className={'items'}>
                        <label className={'label'}>
                            Versão site
                        </label>
                        <label className={'label'}>
                            {item.versao}
                        </label>
                    </div>
                </>}
                <Divider/>
                <div className={'items'}>
                    <label className={'label'}>
                        {item.retorno.message}
                    </label>
                </div>
            </div>)}
        </div>
    </motion.div>
}

export default ListHistory
